export default "__VITE_ASSET__ZZqNqRwt__$_?url__"